import ShopaholicCartAdd from '@lovata/shopaholic-cart/shopaholic-cart-add';

export default new class ProductCard {
  constructor() {
    this.sDefaultInputClass = 'button-change-quantity';
    this.sMiniCartWrapper = '_shopaholic-cart-mini-wrapper';
    this.preLoaderClass = 'product-card__preloader';
    this.wrapperSelector = '_shopaholic-product-wrapper';
    this.tooltipSelector = 'product-card__tooltip';
    this.tooltipVisibleSelector = 'product-card__tooltip_visible';

    this.obShopaholicCartAdd = new ShopaholicCartAdd();

    this.init();
    this.initAddCart();
  }

  init() {
    $(`.${this.sDefaultInputClass}`).on('keydown', (event) => {
      const { key } = event;
      const { value } = event.target;
      const newValue = Number(value + key);
      const max = Number(event.target.max);
      if (newValue > max) { event.preventDefault(); }
    });
  }

  initAddCart() {
    this.obShopaholicCartAdd.setAjaxRequestCallback((obRequestData, obButton) => {
      const wrapper = obButton.closest(`.${this.wrapperSelector}`);
      const tooltip = wrapper.querySelector(`.${this.tooltipSelector}`);
      if (tooltip) {
        clearTimeout(this.timer);
        tooltip.classList.remove(this.tooltipVisibleSelector);
      }
      /* eslint-disable  no-param-reassign */
      obRequestData.update = {
        'product/cart/cart-mini/cart-info/cart-info': `.${this.sMiniCartWrapper}`,
        'product/cart/cart-mini/cart-info/cart-info-mobile': '.mobile-nav__cart-item',
      };
      obRequestData.loading = `.${this.preLoaderClass}`;
      obRequestData.complete = ({ responseJSON }) => {
        this.obShopaholicCartAdd.completeCallback(responseJSON, obButton);
        if (tooltip) {
          tooltip.classList.add(this.tooltipVisibleSelector);
          this.timer = setTimeout(() => {
            tooltip.classList.add('animate__fadeOut');
          }, 5000);
        }
        // const btnData = obButton.getAttribute('data-request-data');
        // $.request('CardForm::onAddRefreshCard', btnData);
      };
      /* eslint-enable */

      return obRequestData;
    }).init();
  }
}();
